import { c as _c } from "react/compiler-runtime";
import { MaterialIcon, MaterialIconPropertiesType } from "@website/icons/material";
import { USER_TRACKING_EVENTS } from "@website/tracking/tracking.types";
import { Button } from "@website/ui/button";
import { CollapsibleText } from "@website/ui/collapsible-text";
import { Modal } from "@website/ui/modal";
import { numberConvert } from "@website/utils/number-convert";
import { FacilitiesItem, ReserveFacilitiesPropertiesTypes } from "@website/widget/reserve-facilities/reserve-facilities.types";
import debounce from "lodash-es/debounce";
import upperFirst from "lodash-es/upperFirst";
import { useRouter } from "next/router";
import { useRef, useState } from "react";
export const ReserveFacilities = t0 => {
  const $ = _c(26);
  const {
    facilitiesGroup,
    hotelType,
    hotelTitle,
    facilities,
    onModalScrollChange
  } = t0;
  const router = useRouter();
  const reference = useRef(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  let t1;
  if ($[0] !== onModalScrollChange) {
    t1 = debounce(value => {
      if (onModalScrollChange) {
        onModalScrollChange(Number(Math.min(100, Math.max(0, value))));
      }
    }, 1000);
    $[0] = onModalScrollChange;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const throttledModalScrollHandler = useRef(t1).current;
  let t2;
  if ($[2] !== router) {
    t2 = facilities_0 => facilities_0?.map(facility => <div className="flex flex-row items-center gap-4 py-2" key={facility.title}><MaterialIcon className="text-xl" name={facility.icon as MaterialIconPropertiesType["name"] || "check_box"} variant="outlined" /><span className="text-black opacity-70">{upperFirst(numberConvert(facility.title, {
          locale: router.locale
        }))}</span></div>);
    $[2] = router;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const getElements = t2;
  let t3;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = () => {
      const element = reference.current;
      if (!element) {
        return;
      }
      const {
        scrollTop,
        scrollHeight,
        clientHeight
      } = element;
      const value_0 = scrollTop / (scrollHeight - clientHeight) * 100;
      throttledModalScrollHandler(value_0);
    };
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  const onScroll = t3;
  if (!facilities?.length) {
    return null;
  }
  const t4 = `${facilities?.length >= 12 ? "h-[180px]" : ""}`;
  let t5;
  if ($[5] !== facilities || $[6] !== getElements) {
    t5 = getElements(facilities);
    $[5] = facilities;
    $[6] = getElements;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  const t6 = `امکانات ${hotelType}`;
  let t7;
  if ($[8] !== facilitiesGroup) {
    t7 = Object.entries(facilitiesGroup || {});
    $[8] = facilitiesGroup;
    $[9] = t7;
  } else {
    t7 = $[9];
  }
  const t8 = t7.length > 0;
  let t9;
  if ($[10] !== facilitiesGroup) {
    t9 = Object.entries(facilitiesGroup || {}).length > 0 ? () => setIsModalOpen(_temp) : undefined;
    $[10] = facilitiesGroup;
    $[11] = t9;
  } else {
    t9 = $[11];
  }
  let t10;
  if ($[12] !== t4 || $[13] !== t5 || $[14] !== t6 || $[15] !== t8 || $[16] !== t9) {
    t10 = <CollapsibleText ariaLabel="facilities" buttonClassName="border-on-surface-high-emphasis text-button h-[40px] w-full rounded-[2rem] border py-2 md:w-[154px] flex justify-center !text-black mt-2" className="text-subtitle-2 mt-2 grid gap-x-5 md:grid-cols-2 xl:grid-cols-3" collapsedClassName={t4} content={t5} lessText={"\u0628\u0633\u062A\u0646"} moreText={"\u0645\u0634\u0627\u0647\u062F\u0647 \u0647\u0645\u0647 \u0627\u0645\u06A9\u0627\u0646\u0627\u062A"} eventKey={process.env.NEXT_PUBLIC_APP_NAME === "villa" ? USER_TRACKING_EVENTS.VILLA_AMENITIES_MODAL_OPEN : undefined} title={t6} titleStyle="text-subtitle-1 md:text-headline-6" hasCustomBehaviourButton={t8} onButtonClick={t9} />;
    $[12] = t4;
    $[13] = t5;
    $[14] = t6;
    $[15] = t8;
    $[16] = t9;
    $[17] = t10;
  } else {
    t10 = $[17];
  }
  let t11;
  if ($[18] !== facilitiesGroup || $[19] !== hotelTitle || $[20] !== isModalOpen || $[21] !== router) {
    t11 = facilitiesGroup && <Modal className="!h-[90vh] overflow-y-scroll rounded-xl !py-3 md:!h-full md:rounded-none lg:!h-[640px] lg:!w-[720px]" headerStyle="!h-16 " onClose={() => setIsModalOpen(false)} open={isModalOpen} showCloseButton={false} titleClassName="line-clamp-2" usePortal={true}><div className="flex items-center justify-between pb-2"><div className="flex flex-col gap-1"><h6 className="text-subtitle-1">امکانات اقامتگاه</h6><p className="text-extra-caption text-on-surface-high-emphasis">{hotelTitle}</p></div><div><Button variant="text" color="neutral" size="x-small" className="!p-0" onClick={() => setIsModalOpen(false)}><MaterialIcon className="!mx-0 text-[24px]" name="close" /></Button></div></div><div ref={reference} onScroll={onScroll} className="no-scrollbar flex-1 overflow-auto md:border-y">{Object.entries(facilitiesGroup).map((t12, index) => {
          const [title, items] = t12;
          return <div className={`${index === Object.entries(facilitiesGroup).length - 1 ? "" : "border-b"} py-4`} key={index}><p className="text-subtitle-1">{title}</p><div className="flex w-full flex-col flex-wrap md:flex-row">{items.map(item => <div className="flex w-full items-center gap-4 py-4 md:w-1/2 md:flex-row md:py-2" key={`${item.title}-${index}`}><MaterialIcon className="text-on-surface-medium-emphasis text-xl" name={item.icon as MaterialIconPropertiesType["name"] || "check_box"} variant="outlined" /><div className="flex w-[98%] flex-col"><span className="text-subtitle-2">{upperFirst(numberConvert(item.title, {
                      locale: router.locale
                    }))}</span>{item?.description && <span className="text-body-2">{numberConvert(item?.description, {
                      locale: router.locale
                    })}</span>}</div></div>)}</div></div>;
        })}</div><div className="flex justify-end"><Button className="mt-4 w-full sm:w-[100px]" color="neutral" onClick={() => setIsModalOpen(false)} text={"\u0628\u0633\u062A\u0646"} variant="outline" /></div></Modal>;
    $[18] = facilitiesGroup;
    $[19] = hotelTitle;
    $[20] = isModalOpen;
    $[21] = router;
    $[22] = t11;
  } else {
    t11 = $[22];
  }
  let t12;
  if ($[23] !== t10 || $[24] !== t11) {
    t12 = <div className="flex md:max-w-[720px] md:flex-row md:flex-wrap xl:max-w-[1200px]" id="hotel_facilities">{t10}{t11}</div>;
    $[23] = t10;
    $[24] = t11;
    $[25] = t12;
  } else {
    t12 = $[25];
  }
  return t12;
};
function _temp(previous) {
  return !previous;
}